/**
 * The errors read again when a fill ends (21/10/2026): the server resolves
 * the "texts not filled" errors right after it stamps the fill done, so the
 * Errors tab, its header tile and the index badges ask again a moment later
 * — the 30 s poll would leave a fixed error looking open meanwhile.
 * For Media Devoted | Created By Ciro Autiero
 */
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { dropGeneratorKeys } from '../../useDropGenerator';

/** After the server's resolve step (it runs right after the fill is stamped done). */
export const REFRESH_DELAY_MS = 1500;

export function useRefreshErrors(): () => void {
  const qc = useQueryClient();
  return useCallback(() => {
    setTimeout(() => {
      void qc.invalidateQueries({ queryKey: [...dropGeneratorKeys.all, 'errors'] });
      void qc.invalidateQueries({ queryKey: [...dropGeneratorKeys.all, 'errors-summary'] });
    }, REFRESH_DELAY_MS);
  }, [qc]);
}
